import EventParticipationRateBarChart from 'widgets/EventParticipationRateBarChart/EventParticipationRateBarChart'

export default EventParticipationRateBarChart
